import { register } from '../../../JavaScript/Utils'

const MobileNavigation = el => {
  let activeOuterContainer = null
  let activeInnerContainer = null

  const togglerItems = el.querySelectorAll('.toggler-item')

  const clickTogglerItem = e => {
    const isInner = e.currentTarget.dataset.type === 'inner'

    if (activeInnerContainer) {
      activeInnerContainer.classList.remove('is--active')
    }

    if ((activeOuterContainer && !isInner)) {
      activeOuterContainer.classList.remove('is--active')
    }

    const targetElement = e.currentTarget.closest('.toggler-container')

    if (targetElement !== activeOuterContainer && targetElement !== activeInnerContainer) {
      targetElement.classList.add('is--active')

      if (isInner) {
        activeInnerContainer = targetElement
      } else {
        activeOuterContainer = targetElement
      }
    } else {
      activeInnerContainer = null

      if (!isInner) {
        activeOuterContainer = null
      }
    }

    targetElement.scrollIntoView({ behavior: 'smooth' })
  }

  togglerItems.forEach(item => item.addEventListener('click', clickTogglerItem))
}

register('MobileNavigation', MobileNavigation)
